import React, {useState} from "react";
import {useAuth} from "../../../providers/AuthProvider";
import {useMutation} from "@tanstack/react-query";
import {useParams} from "react-router-dom";
import AgencyOpportunity from "../../../models/AgencyOpportunity";
import Opportunity from "../../../models/Opportunity";
import {useAPI} from "../../../config/API";
import TalentCandidate from "../../../models/TalentCandidate";
import {usePosition} from "../../../providers/ProjectPositionProvider";
import Project from "../../../models/Project";

let TalentCandidateScopeContext = React.createContext(null);

const TalentCandidateScopeProvider = ({opportunityId, forAssigned, candidate, project, children, ...props}) => {
    const {
        position,
        isDisabled,
        updatePosition
    } = usePosition();

    const {auth} = useAuth();
    const {candidateId: paramId} = useParams();

    const candidateId = candidate ? candidate.job_candidate?.id : (forAssigned ? position?.assigned_candidate?.job_candidate?.id : paramId);
    const [candidateScopeModel, setCandidateScopeModel] = useState( () => candidate ? TalentCandidate.normalizeScopeForPosition(candidate, position) : null);

    const {
        data,
        isLoading: isLoadingCandidate,
        error,
        refetch
    } = useAPI(['fetchTalentCandidateScope', parseInt(candidateId)],  {
        enabled: !candidate,
        onSuccess: async (response) => {


            if (response) {
                console.log('onSuccess Talent Scope', TalentCandidate.normalizeScopeForPosition(response, position));
                await setCandidateScopeModel(TalentCandidate.normalizeScopeForPosition(response, position));
            }
        },
    })

    const updateQueryCallback = async (updatedCandidate) => {
        console.log('TalentCandidateScopeProvider@updateCallback', updatedCandidate?.job_candidate.id, candidateId)
        let scoped = TalentCandidate.normalizeScopeForPosition({...updatedCandidate}, position);

        // console.log('updateQueryCallback', scoped)
        // if (team) {

        // }
        await setCandidateScopeModel(scoped);
        if (candidate && candidate.job_candidate.id === position.assigned_candidate?.job_candidate.id) {
            // TODO update contract and payout values
            console.log('updateQueryCallbackRESET CANDIDATE')
            // await updatePosition({assigned_candidate: scoped});
        }
        if (opportunityId) {
            let opp = await TB.queryClient.getQueryData(['fetchOpportunityForAgency', opportunityId])
            if (!opp) return;

            let updatedOpp = {...opp};
            updatedOpp.matching_talent = TB.map(updatedOpp.matching_talent, talent => {
                if (talent.job_candidate.id === parseInt(candidateId)) {
                    return {
                        ...talent,
                        job_candidate: {
                            ...talent.job_candidate,
                            ...scoped.job_candidate
                        }
                    };
                }
                return talent;
            })

            updatedOpp = AgencyOpportunity.make(updatedOpp);
            await Opportunity.refreshCacheFor(
                updatedOpp
            );
        }
        await TB.queryClient.setQueryData(['fetchTalentCandidateScope', parseInt(candidateId)], previousData => {
            if (!previousData) return undefined;

            return scoped
        })
        await TB.queryClient.setQueryData({
            predicate: ({queryKey}) => {
                return queryKey[0] === 'positionMatches'
            }
        }, previousData => {
            if (!previousData) return undefined;

            let data = {...previousData};
            data.users = TB.map(data.users, user => {
                if (user.id === scoped.id) {
                    return scoped;
                }
                return user;
            })
            return data;
        })

    }
    const updateCandidateScopeMutation = useMutation(
        ['updateCandidateScope', candidateId],
        async (params) => {

            console.log('updateCandidateScope', params);

            let request = TB.request(`/api/job-candidates/talent-users/${candidateId}/update-scope`, params).headers({
                'Content-Type': 'multipart/form-data'
            });

            let response = await request.post().catch(console.warn);

            return response
        }
    )

    const updateCandidateTalentOppMutation = useMutation(
        ['updateCandidateTalentOpp', candidateId],
        async (callback) => {

            return callback()
        },{
            onSuccess: async (updatedOpp) => {
                let oppIndex = TB.findIndex(candidateScopeModel.job_candidate.talent_opps, ['id', updatedOpp.id])

                if (oppIndex < 0) {
                    throw new Error("Opp not found")
                }
                let updatedCandidate = TB.set({...candidateScopeModel}, `job_candidate.talent_opps[${oppIndex}]`, updatedOpp);

                updatedCandidate = TalentCandidate.normalizeScopeForPosition(updatedCandidate, position)
                await updateQueryCallback(updatedCandidate)
                return TB.toast("Sent reminder to Talent!")
            },
            onError: (error) => {
                console.warn('sendRemindToAccept', error);
                TB.showServerErrorToast()
            },
        }
    )

    const confirmCandidateScope = async() => {
        if (candidateScopeModel.hasConfirmedScope() && candidateScopeModel.hasConfirmedPayout()) {
            return TB.toast("Candidate Scope already confirmed.", {theme: 'danger'})
        }
        if (!candidateScopeModel.canConfirmScope()) {
            await TB.alert('error', 'Missing Deliverables',
                'The candidate scope must have assigned hours for each deliverable from the original role scope.', [
                {title: 'Ok'}
            ]);

            return;
        }

        let updates = {payout_confirmed_at: new Date(),scope_confirmed_at: new Date()};
        let response = await updateCandidateScope(updates, false);

        if (response && response.job_candidate?.has_confirmed_scope) {
            return TB.alert('success', 'Candidate Scope Confirmed',
                'The candidate\'s proposal will now be available for client review.', [
                {title: 'Ok'},
            ]);
        }
    }

    const updateCandidateScope = async (params, showSuccess = true) => {
        let response = await updateCandidateScopeMutation.mutateAsync(params);
        if (TB.has(response, 'success.data.project')) {

            let updatedCandidate = TalentCandidate.normalizeScopeForPosition({...response.success.data.talent_user}, position);

            console.log('updateCandidateScope', Project.make({...response.success.data.project}))
            await Project.refreshCacheFor(Project.make({...response.success.data.project}))

            if (showSuccess) {
                TB.toast("Candidate Scope Updated");
            }
            return updatedCandidate;
        }else if (TB.has(response, 'success.data.talent_user')) {

            let updatedCandidate = TalentCandidate.normalizeScopeForPosition({...response.success.data.talent_user}, position);

            await updateQueryCallback(updatedCandidate);
            if (showSuccess) {
                TB.toast("Candidate Scope Updated");
            }
            return updatedCandidate;
        }

        TB.showServerErrorToast();
        return false;
    }

    const resetModel = async () => {
        let reset = TalentCandidate.normalizeScopeForPosition(candidate ? {...candidate} : {...data}, position);
        setCandidateScopeModel(reset)
    }

    const onContactCandidateMember = (params) => {

        return updateCandidateScope({...candidateScopeModel, message_to_talent: params.message_to_talent})
    }

    const onUpdateProposal = async(params = {}) => {
        let updatedCandidate = await updateCandidateScope(params, false);

        if (updatedCandidate) {
            TB.toast("Candidate Proposal Updated");
            return updatedCandidate;
        }
        TB.showServerErrorToast();
    }
    const sendRemindToAccept = async(opp) => {

        if (opp.reminded_to_accept_at) {
            return TB.toast("Reminder Already Sent", {type:'info'})
        }
        return updateCandidateTalentOppMutation.mutate(() => opp.sendRemindToAccept());
    }

    const uploadTalentContract = async(oppId, params = {}) => {
        if (!auth.canManageClients()) {
            return TB.showPermissionError();
        }

        return updateCandidateTalentOppMutation.mutate(async() => {
            const uploadRequest = TB.request(
                TB.api_endpoint(
                    `/api/talent-user-opportunities/${oppId}/update-contract`
                ), params
            );
            console.log('uploadtalentcontract', {params, oppId})

            uploadRequest.headers({
                'Content-Type': 'multipart/form-data'
            });

            let response = await uploadRequest.post().catch(e => {
                console.warn("UPDATE", e)
            });

            console.log('Success', {response})
            if (!TB.has(response, 'success.data.opportunity')) {
                throw new Error('Something went wrong');
            }
            return Opportunity.make(response.success.data.opportunity)
        })
    }

    const value = {
        candidate: candidateScopeModel,
        data,
        isLoading: !candidate && isLoadingCandidate,
        error,
        isDisabled: isDisabled || updateCandidateScopeMutation.isLoading || updateCandidateTalentOppMutation.isLoading,
        onChange: (props) => {
            let updatedCandidate = TalentCandidate.normalizeScopeForPosition({...candidateScopeModel, ...props}, position);
            console.log('onChangeProvider', props)
            return updateQueryCallback(updatedCandidate)
        },
        resetModel,
        sendRemindToAccept,
        updateCandidateScope,
        onUpdateProposal,
        uploadTalentContract,
        confirmCandidateScope,
        onContactCandidateMember
    }

    return (
        <TalentCandidateScopeContext.Provider value={value}>
            {children}
        </TalentCandidateScopeContext.Provider>
    );
}

const useTalentCandidateScope = () => {
    return React.useContext(TalentCandidateScopeContext);
}

export default TalentCandidateScopeProvider;

export {useTalentCandidateScope, TalentCandidateScopeContext}